// @ts-check

import {
  ASK_QUESTIONS_SKIP_ALL_NONE,
  ASK_QUESTIONS_SKIP_ONE_LINE,
  ASK_QUESTIONS_SKIP_REMAINING,
} from "./askQuestions.constants"

/**
 * @typedef {object} AskQuestionDef
 * @property {string} id
 * @property {string} question
 * @property {string[]} options
 * @property {boolean} multiple
 */

/**
 * @typedef {object} AnsweredState
 * @property {'answered'} kind
 * @property {string[]} selections
 * @property {string} custom
 */

/**
 * @typedef {object} SkippedState
 * @property {'skipped'} kind
 */

/**
 * @typedef {AnsweredState | SkippedState} PerQuestionState
 */

/**
 * @param {AskQuestionDef} q
 * @param {AnsweredState} st
 * @returns {string}
 */
export function formatAnsweredQuestionLine(q, st) {
  const parts = []
  if (q.multiple) {
    for (const s of st.selections) {
      if (s && s.trim()) parts.push(s.trim())
    }
  } else if (st.selections[0]?.trim()) {
    parts.push(st.selections[0].trim())
  }
  const c = st.custom.trim()
  if (c) parts.push(c)
  return parts.join(q.multiple ? "; " : " · ")
}

/**
 * @param {AskQuestionDef[]} questions
 * @param {Record<string, PerQuestionState | undefined>} byId
 * @param {'submit' | 'skip-all'} mode
 * @returns {string}
 */
export function buildAskQuestionsOutputString(questions, byId, mode) {
  if (questions.length === 0) return ""

  const hasAnyAnswered = questions.some((q) => byId[q.id]?.kind === "answered")

  if (mode === "skip-all" && !hasAnyAnswered) {
    return ASK_QUESTIONS_SKIP_ALL_NONE
  }

  const lines = questions.map((q, index) => {
    const label = `Pregunta ${index + 1}`
    const st = byId[q.id]
    if (st?.kind === "answered") {
      return `${label}: ${formatAnsweredQuestionLine(q, st)}`
    }
    if (st?.kind === "skipped") {
      return `${label}: ${ASK_QUESTIONS_SKIP_ONE_LINE}`
    }
    return `${label}: ${ASK_QUESTIONS_SKIP_REMAINING}`
  })

  return lines.join("\n")
}
